export interface ImportSummary { added: number; updated: number; unchanged: number; duplicates: number; rejected: number }
export const normalizeRosterRow = (r: { cui: string; name: string }) => ({ cui: r.cui.trim(), name: r.name.trim().replace(/\s+/g, ' ') })
// CSV/TSV with quoted names. Reject the whole file rather than silently omit rows.
export function parseRoster(text: string): { cui: string; name: string }[] {
  const source = text.replace(/^\uFEFF/, '')
  for (const delimiter of [',', ';', '\t']) {
    const rows: string[][] = []
    let row: string[] = [], cell = '', quoted = false
    for (let i = 0; i < source.length; i++) {
      const c = source[i]
      if (c === '"') {
        if (quoted && source[i + 1] === '"') { cell += '"'; i++ }
        else quoted = !quoted
      } else if (!quoted && (c === delimiter || c === '\n' || c === '\r')) {
        row.push(cell.trim()); cell = ''
        if (c !== delimiter) {
          if (row.some(Boolean)) rows.push(row)
          row = []
          if (c === '\r' && source[i + 1] === '\n') i++
        }
      } else cell += c
    }
    if (quoted) throw new Error('CSV inválido: hay comillas sin cerrar.')
    row.push(cell.trim()); if (row.some(Boolean)) rows.push(row)
    const headers = (rows[0] || []).map(c => c.toLowerCase())
    const cuiIndex = headers.findIndex(c => /^(cui|codigo|código)$/.test(c))
    const nameIndex = headers.findIndex(c => /nombre|apellidos|alumno/.test(c))
    if (cuiIndex < 0 || nameIndex < 0) continue
    if (rows.length < 2 || rows.length > 5001) throw new Error('El archivo debe contener de 1 a 5000 alumnos.')
    const students = rows.slice(1).map((r, index) => {
      const { cui, name } = normalizeRosterRow({ cui: r[cuiIndex] || '', name: r[nameIndex] || '' })
      if (r.length !== headers.length || !/^[0-9]{1,12}$/.test(cui) || !name || name.length > 200) throw new Error(`Fila ${index + 2} inválida. Revisa CUI, nombre y columnas. No se importó ningún alumno.`)
      return { cui, name }
    })
    const duplicates = students.length - new Set(students.map(s => s.cui)).size
    if (duplicates) throw new Error(`El archivo contiene ${duplicates} CUI duplicados. Archivo rechazado; no se importó ningún alumno.`)
    return students
  }
  throw new Error('No se detectaron las columnas CUI y Apellidos y Nombres.')
}
